import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import b from 'b_';
import moment from 'moment';
import BrowserStore from '../../browser/stores/BrowserStore';
import FuseBrowserModal from '../BrowserModal/FuseBrowserModal';
import Card from '../Fuse/Card';
import { FTBody, FTBodySm } from '../Fuse';
import { FILE_PROCESSING_STATE } from '../../mirror/sharedConstants';
import FileEventController from '../../browser/FileEventController';
import BrowserModalCard from '../Fuse/BrowserModalCard';
import Icon from '../Icon/Icon';

import './BlockedFilesModal.css';

const block = b.lock('BlockedFilesModal');


class BlockedFilesModal extends Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        browser: BrowserStore.PropType.isRequired,
    };

    formatTimestamp = (timestamp) => {
        const momentObj = moment(timestamp);
        return momentObj.isValid()
            ? momentObj.format('YYYY-MM-DD [at] HH:mm:ss')
            : timestamp;
    };

    handleBack = () => {
        const { browser } = this.props;
        browser.blockedFilesModal.close();
        browser.topBarMenu.open();
    };

    render() {
        const {
            t,
            browser
        } = this.props;
        const { fileManagerStore } = browser;
        const visibleCards = fileManagerStore.blockedFilesEvents
            .filter((event) => event.state !== FILE_PROCESSING_STATE.CANCELED);
        const hasVisibleCards = visibleCards.length > 0;

        return <FuseBrowserModal
            small
            hideFooter
            title={t('Notification.BlockedFilesModal.title')}
            isOpen={browser.blockedFilesModal.isOpen}
            onClose={() => browser.blockedFilesModal.close()}
            onBack={this.handleBack}
        >
            {!hasVisibleCards && <BrowserModalCard
                title={t('Notification.BlockedFilesModal.empty.title')}
                titleIcon={'web'}
            ><FTBodySm className={block('Text')}>{t('Notification.BlockedFilesModal.empty.text')}</FTBodySm>
            </BrowserModalCard>}
            {visibleCards.map((event) => {
                return <FileEventController
                    key={event.id}
                    fileEvent={event}
                    render={(data) => <Card className={block('Content')}>
                        <div className={block('BlockedFileRow')}>
                            <Icon className={block('FileEventIcon')} type={data.icon}/>
                            <div className={block('BlockedFilesEventInfo')}>
                                <div className={block('Label')}>
                                    {this.formatTimestamp(event.startTime)}
                                </div>
                                <FTBody className={block('FileName')}>{event.name}</FTBody>
                            </div>
                        </div>
                        <div className={
                            block('FileStatusText', {
                                type: data.notificationType,
                                isList: true
                            })
                        }
                        >
                            {data.notificationStatus}
                        </div>

                    </Card>}
                />;
            })}
        </FuseBrowserModal>;
    }
}

export default translate()(inject('browser')(observer(BlockedFilesModal)));
